import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./Success.css";
import BrandlyLogo from "../../assets/BrandlyLogo.png"; // adjust path if needed

const Success = () => {
  const queryParams = new URLSearchParams(useLocation().search);
  const subscriptionId = queryParams.get("subscription_id");
  const status = queryParams.get("status");
  const navigate = useNavigate();

  const [quota, setQuota] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchQuota = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/api/subscriptions/me/quota`, {
          credentials: "include",
        });
        if (res.ok) {
          const data = await res.json();
          setQuota(data);
        }
      } catch (err) {
        console.error("Failed to fetch quota", err);
      } finally {
        setLoading(false);
      }
    };
    fetchQuota();
  }, []);

  const handleReturn = () => navigate("/dashboard");

  return (
    <div className={`success-page ${status === "active" ? "success" : "failed"}`}>
      <div className="success-card">
        <img src={BrandlyLogo} alt="Brandly Logo" className="success-logo" />

        {status === "active" ? (
          <>
            <h1>🎉 Subscription Active!</h1>
            <p>Your subscription <b>{subscriptionId}</b> is now <b>active</b>.</p>
          </>
        ) : (
          <>
            <h1>❌ Payment Failed</h1>
            <p>Your subscription <b>{subscriptionId}</b> has <b>{status}</b> status.</p>
          </>
        )}

        {loading ? (
          <p>Loading subscription details...</p>
        ) : quota ? (
          <div className="quota-details">
            <h2>Plan: {quota.plan_name?.split("-")[0].toUpperCase()}</h2>
            <div className="features-grid">
              <div className="feature-item">
                <h3>Posts</h3>
                <p>{quota.plan_limits.post} total</p>
                
              </div>
              <div className="feature-item">
                <h3>Hooks</h3>
                <p>{quota.plan_limits.hooks} total</p>
                
              </div>
              <div className="feature-item">
                <h3>Free Tools</h3>
                <ul>
                  {quota.plan_features.summary_generator && <li>Summary Generator</li>}
                  {quota.plan_features.headlines_generator && <li>Headlines Generator</li>}
                  {quota.plan_features.video_downloader && <li>Video Downloader</li>}
                </ul>
              </div>
            </div>
          </div>
        ) : (
          <p>Unable to load subscription details.</p>
        )}

        <button className="return-btn" onClick={handleReturn}>
          Return to Dashboard
        </button>
      </div>
    </div>
  );
};

export default Success;
